import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSpeichernVerlassen = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "19px",
	height: "34px",
	viewBox: "0 0 19 34",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Unvollst\\xE4ndige-Bewertungen",
			transform: "translate(-13.000000, -163.000000)",
			fill: "#FFFFFF",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("g", {
				id: "next",
				transform: "translate(22.500000, 180.000000) scale(-1, 1) translate(-22.500000, -180.000000) translate(13.000000, 163.000000)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M0.609587506,30.3796053 L13.9009241,17 L0.609587506,3.62039466 C-0.206708517,2.78864321 -0.202670227,1.44947979 0.618627054,0.622732312 C1.43992433,-0.204015162 2.77025955,-0.208080251 3.59652782,0.613632777 L18.3814005,15.4966191 C19.2061998,16.3269224 19.2061998,17.6730776 18.3814005,18.5033809 L3.59652782,33.3863672 C2.77025955,34.2080803 1.43992433,34.2040152 0.618627054,33.3772677 C-0.202670227,32.5505202 -0.206708517,31.2113568 0.609587506,30.3796053 L0.609587506,30.3796053 Z",
					id: "Path"
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgIconSpeichernVerlassen);
export { ForwardRef as ReactComponent };
